import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { PrivateOutlet } from './Layouts/PrivateOutlet';

import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import "bootstrap/dist/css/bootstrap.rtl.min.css"
import "bootstrap/dist/js/bootstrap.bundle"

import Home from './Pages/Home';
import Blog from './Pages/Blog';
import Post from './Pages/Post';
import Login from './Pages/Login';
import Signup from './Pages/Signup';
import Dashboard from './Pages/Panel/Dashboard';
import Error404 from './Layouts/Error404';
import Bookmark from './Pages/Panel/Bookmark';
import { MainOutlet } from './Layouts/MainOutlet';
import Contact from './Pages/Contact';
import Exams from './Pages/Panel/Exams';
import UserExams from './Pages/Panel/UserExams';
import Package from './Pages/Panel/Package';
import Exam from './Pages/Panel/Exam';
import ExamReview from './Pages/Panel/ExamReview';
import Leitner from './Pages/Panel/Leitner';
import LeitnerReview from './Pages/Panel/LeitnerReview';
import LeitnerStudy from './Pages/Panel/LeitnerStudy';
import Reset from './Pages/Reset';
import Referral from './Pages/Panel/Referral';
import ExamHistoryCharts from './Pages/Panel/ExamHistoryCharts';

function App() {
  const location = useLocation();

  useEffect(() => {
    const isRealExamPath = location.pathname.startsWith('/panel/exam/real/');
    if (!isRealExamPath) return;

    const handleCopy = (e: { preventDefault: () => void; }) => {
      e.preventDefault();
    };

    document.addEventListener('copy', handleCopy);
    return () => {
      document.removeEventListener('copy', handleCopy);
    };
  }, [location.pathname]);

  return (
    <Routes>
        <Route path="*" element={<MainOutlet />}>
          <Route index element={<Home />} />
          <Route path="blog/:catId?" element={<Blog />} />
          <Route path="post/:id/:name?" element={<Post />} />
          <Route path="contact" element={<Contact />} />
          <Route path="login" element={<Login />} />
          <Route path="reset-pass" element={<Reset />} />
          <Route path="signup" element={<Signup />} />
          <Route path="*" element={<Error404 />} />
        </Route>
        <Route path="panel/*" element={<PrivateOutlet />}>
          <Route index element={<Dashboard />} />
          <Route path="leitner" element={<Leitner />} />
          <Route path="leitner/study" element={<LeitnerStudy />} />
          <Route path="leitner/review" element={<LeitnerReview />} />
          <Route path="leitner/review/:box" element={<LeitnerReview />} />
          <Route path="referral" element={<Referral />} />
          <Route path="exams" element={<Exams />} />
          <Route path="exam-history-charts" element={<ExamHistoryCharts />} />
          <Route path="exam">
            <Route path="review/:uxId/:qId?" element={<ExamReview />} />
            <Route path=":type/:eId/:qId?" element={<Exam />} />
          </Route>
          <Route path="user-exams" element={<UserExams />} />
          <Route path="bookmark" element={<Bookmark />} />
          <Route path="package" element={<Package />} />
          <Route path="*" element={<Error404 />} />
        </Route>
    </Routes>
  );
}

export default App;
library.add(fab, fas, far)
